import { ElevenLabsClient, play } from "elevenlabs";

export const generateAndPlayAudio = async (text: string) => {
  const elevenlabs = new ElevenLabsClient({
    apiKey: process.env.REACT_APP_ELEVENLABS_API_KEY,
  });
  const audio = await elevenlabs.generate({
    voice: "Rachel",
    text,
    model_id: "eleven_multilingual_v2",
  });

  await play(audio);
};

export const formatElapsedTime = (elapsedTime: number): string => {
  const minutes = Math.floor(elapsedTime / 60); // Calculate full minutes
  const seconds = elapsedTime % 60; // Get the remainder seconds
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds; // Add leading 0 if necessary
  return `${minutes}:${formattedSeconds}`;
};
